export enum StockStatus {
  InStock = 0,
  Incoming = 1,
  InCentralStoreStock = 2,
  IncomingToCentralStorage = 3,
  Orderable = 4,
  OrderableDirectlyFromSupplier = 5,
  Unavailable = 6,
  NotFound = 7,
}

export enum StockStatusStrings {
  InStock = 'InStock',
  Incoming = 'Incoming',
  InCentralStoreStock = 'InCentralStoreStock',
  IncomingToCentralStorage = 'IncomingToCentralStorage',
  Orderable = 'Orderable',
  OrderableDirectlyFromSupplier = 'OrderableDirectlyFromSupplier',
  Unavailable = 'Unavailable',
  NotFound = 'NotFound',
}
